import React from "react";
import LayerGroup from "../../../../types/LayerGroup";
import LayerLegend from "../sharedComponents/LayerLegend";
import LegendRow from "../sharedComponents/LegendRow";

class HospitalsLegend extends React.PureComponent<{}, {}> {
  render() {
    return (
      <LayerLegend
        layerGroup={LayerGroup.Hospitals}
        classes="hospitals"
        legendRows={[
          <LegendRow
            color="#F10A08"
            text="Health and Medical Facilities"
            circle
          />,
        ]}
      />
    );
  }
}

export default HospitalsLegend;
